// React glue for CASL — self-contained (no @casl/react, which requires React 18).
// The ability instance is supplied by AbilityProvider; components read it with
// the useAbility() hook:
//   const ability = useAbility();
//   if (ability.can('edit', 'DispatchBoard')) { ... }

import { createContext, useContext } from 'react';

export const AbilityContext = createContext(undefined);

export const useAbility = () => useContext(AbilityContext);
